<div class="row">
  <div class="col-xl-12">
    <div class="card card-box mb-3">
      <div class="card-header">
        <div class="card-header--title">
          <h3 class="font-size-lg mb-0 py-2 font-weight-bold">
            Customer Accounts Receivable Dashabord
          </h3>
        </div>
        <div class="card-header--actions">
          <div class="btn-group btn-group-sm" dropdown>
            <!-- <button class="btn btn-sm dropdown-toggle no-caret btn-neutral-primary" dropdownToggle
                          type="button">
                          {{filterSelection}}
                          <fa-icon [icon]="['fas', 'chevron-down']" class="opacity-8 font-size-xs ml-1"></fa-icon>
                      </button>
                      <div *dropdownMenu class="dropdown-menu dropdown-menu-xl dropdown-menu-right">
                          <ul class="nav nav-neutral-dark nav-pills flex-column px-3">
                              <li class="nav-item nav-item--header px-0">
                                  <span class="text-capitalize text-black font-size-md font-weight-bold">Select
                                      Time Period</span>
                              </li>
                              <li class="dropdown-divider"></li>
                              <li class="nav-item">
                                  <a (click)='currentYear()' class="nav-link">
                                      <span>Current Year</span>
                                  </a>
                              </li>
                              <li class="nav-item">
                                  <a (click)='previousYear()' class="nav-link">
                                      <span>Previous Year</span>
                                  </a>
                              </li>
                          </ul>
                      </div> -->
          </div>
        </div>
        <!-- <button tooltip="Refresh" (click)='currentYear()'
                  class="btn d-32 p-0 btn-animated-icon btn-animated-icon--primary btn-neutral-primary ml-2"
                  type="button">
                  <span class="btn-wrapper--icon">
                      <i class="ion-md-sync"></i>
                  </span>
              </button> -->
      </div>
      <div class="card-body pb-1 font-weight-bold">
        <span  width="1140" height="541.25">Dashboard Coming Soon !</span>
        <!-- <iframe title="AR CUSTOMER" width="1140" height="541.25"
          src="https://app.powerbi.com/reportEmbed?reportId=a7421815-b187-4ae7-9821-8840642b4665&autoAuth=true&ctid=335e54b3-01fd-45d4-a9e1-71915d04d7bc"
          frameborder="0" allowFullScreen="true"></iframe> -->
      </div>
    </div>
  </div>
</div>